var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.availableSites?.length > 1)?_c('form-select',{attrs:{"required":true,"options":_vm.locales,"arrow-size":"long","label":"Language","add-label-as-option":false},model:{value:(_vm.selectedLocale),callback:function ($$v) {_vm.selectedLocale=$$v},expression:"selectedLocale"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }